import VMasker from "vanilla-masker/lib/vanilla-masker";
import { MaskPhone, telMask } from "../../components/maskPhone";
import Modal from "../../components/modal/index";

// import { API_PATH } from '../../constants';

(() => {
  console.log("INOVA");

  const form = document.getElementById("InovaSave");
  const action = form.getAttribute("action");
  const inputFiles = document.querySelector('input[name="files[]"]');
  let filesArray = [];

  Dropzone.options.docsDropzone = {
    paramName: "file",
    maxFilesize: 10, // MB,
    dictDefaultMessage: "<b>Clique</b> ou arraste os arquivos",
    acceptedFiles:
      "image/*, video/*, .doc,.docx, .xls, .ppt, .pdf, .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    addRemoveLinks: true,
    uploadMultiple: true,
    parallelUploads: 100,
    maxFiles: 100,
    init: function () {
      this.on("sending", function (file, xhr, formData) {
        const tokenElement = document.querySelector('meta[name="csrf-token"]');
        const token = tokenElement.getAttribute("content");
        formData.append("_token", token);
      });
      this.on("sendingmultiple", function () {
        console.log("sendingmultiple");
      });
      this.on("successmultiple", function (files, response) {
        filesArray = response.files;
        console.log(filesArray);
        inputFiles.value = filesArray;
      });
      this.on("errormultiple", function (files, response) {
        console.log("errormultiple");
        console.log(files, response);
      });

      this.on("addedfile", function (file) {
        const removeButtons = document.querySelectorAll(".removeButton");
        const total = removeButtons.length;
        const removeButton = Dropzone.createElement(
          `<button type="button" data-idfile="${total}" class="removeButton">x</button>`
        );
        const _this = this;
        removeButton.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const button = e.currentTarget;
          const buttons = button
            .closest(".dropzone")
            .querySelectorAll(".removeButton");

          const index = [...buttons].indexOf(button);
          filesArray = filesArray.filter((f, i) => i !== index);

          inputFiles.value = filesArray;
          _this.removeFile(file);
        });

        file.previewElement.appendChild(removeButton);
      });
    },
  };

  const selectors = {
    text1: document.querySelector('textarea[name="text1"]') ?? '',
    desafio_id: document.querySelector('input[type="hidden"][name="desafio_id"]') ?? null,
    text2: document.querySelector('textarea[name="text2"]'),
    text3: document.querySelector('textarea[name="text3"]'),
    name: document.querySelector('input[name="name"]'),
    cnpj: document.querySelector('input[name="cnpj"]'),
    link: document.querySelector('input[name="link"]'),
    nameResponsible: document.querySelector('input[name="nameResponsible"]'),
    email: document.querySelector('input[name="email"]'),
    phone: document.querySelector('input[name="phone"]'),
    area: document.querySelector('select[name="area"]') ?? '',
    optinMessage: document.querySelector('input[name="optinMessage"]'),
    optinTerms: document.querySelector('input[name="optinTerms"]'),
    submit: document.getElementById("btn-send"),
    btnOk: document.getElementById("btn-ok"),
    msgSuccess: document.getElementById("modal-message__desc"),
    msgStatus: document.getElementById("modal-message__status"),
  };

  document.querySelector('input[name="cnpj"]').addEventListener('input', function (e) {
    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/);
    e.target.value = !x[2] ? x[1] : x[1] + '.' + x[2] + '.' + x[3] + '/' + x[4] + (x[5] ? '-' + x[5] : '');
  });

  const modalElements = {
    modalMessage: "#modal-message",
  }

  /* console.log(selectors); */
  const messages = {
    ok: "<h1>Desafio aceito com sucesso!</h1><p>Obrigado por nos enviar um desafio!<br><br>Nosso time vai analisar os dados enviados e entraremos em contato o mais breve possível!</p>",
    failed: "Oops, tente novamente mais tarde.",
    voltar: "Voltar",
  };
  const cssClasses = {
    errorClass: "error",
    loading: "is-loading",
    // success: "icon-status--success",
    failed: "icon-status--failed",
  };
  const modal = new Modal(modalElements.modalMessage, false);

  VMasker(selectors.phone).maskPattern(telMask[0]);
  selectors.phone.addEventListener(
    "input",
    MaskPhone.bind(undefined, telMask, 14),
    false
  );
  if (selectors.btnOk != null) {
    selectors.btnOk.addEventListener("click", () => modal.closeModal());
  }
  document.onkeyup = (evt) => {
    if (evt.keyCode === 13) validate();
  };
  selectors.submit.addEventListener("click", (evt) => {
    console.log('Clicado');
    evt.preventDefault();
    evt.stopPropagation();
    validate();
  });
  selectors.btnOk.addEventListener("click", (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    if (
      !selectors.msgStatus.getAttribute("class").includes(cssClasses.failed)
    ) {
      window.location = "/inova";
    }
  });

  function validate() {
    let val = [];
    let selectorValues = Object.values(selectors);
    selectorValues.forEach(element => {
      if (element) {
        let isValid = validateElement(element);
        val.push(isValid);
      }
    });
    /* validateElement(selectors.optinTerms);
    val.push(validateElement(selectors.text1));
    val.push(validateElement(selectors.text2));
    val.push(validateElement(selectors.text3));
    val.push(validateElement(selectors.name));
    val.push(validateElement(selectors.cnpj));
    val.push(validateElement(selectors.link));
    val.push(validateElement(selectors.nameResponsible));
    val.push(validateElement(selectors.email));
    val.push(validateElement(selectors.phone));
    val.push(validateElement(selectors.area)); */
    // val.push(validateElement(selectors.optinMessage));
    /* val.push(validateElement(selectors.optinTerms)); */

    if (!val.includes(false)) {
      onSend();
    }
  }
  function validateElement(el) {

    if (el.type == "checkbox") {
      console.log(el.type, el.checked);
      if (!el.checked) {
        selectors.msgStatus.classList.add(cssClasses.failed);
        selectors.msgSuccess.innerHTML = "Você precisa aceitar os termos";
        modal.openModal();
        return false;
      } else {
        return true;
      }
    } else {
      if (el && 'length' in el) {
        if (el.value.length > 0) {
          el.classList.remove(cssClasses.errorClass);
          return true;
        } else {
          el.classList.add(cssClasses.errorClass);
          return false;
        }
      }
    }
  }
  function onSend() {
    const data = {
      text1: selectors.text1.value,
      text2: selectors.text2.value,
      text3: selectors.text3.value,
      desafio_id: selectors.desafio_id !== null ? selectors.desafio_id.value : null,
      name: selectors.name.value,
      cnpj: selectors.cnpj.value,
      link: selectors.link.value,
      nameResponsible: selectors.nameResponsible.value,
      email: selectors.email.value,
      phone: selectors.phone.value,
      area: selectors.area.value,
      optinMessage: selectors.optinMessage.checked ? 1 : 0,
      optinTerms: selectors.optinTerms.checked ? 1 : 0,
      filesJson: inputFiles.value,
    };
    console.log(data);
    selectors.submit.classList.add(cssClasses.loading);
    axios
      .post(`${action}`, data)
      .then((response) => {
        if (response.data.success) {
          selectors.submit.classList.remove(cssClasses.loading);
          selectors.msgStatus.classList.remove(cssClasses.failed);
          selectors.msgStatus.classList.add(cssClasses.success);
          selectors.msgSuccess.innerHTML = messages.ok;
          selectors.btnOk.innerHTML = messages.voltar;
          modal.openModal();
        } else {
          selectors.submit.classList.remove(cssClasses.loading);
          if (selectors.msgStatus != null)
            selectors.msgStatus.classList.add(cssClasses.failed);
          selectors.msgSuccess.innerHTML = messages.failed;
          selectors.btnOk.innerHTML = "OK";
          modal.openModal();
          console.log("POST Error ->", response.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response);
        selectors.submit.classList.remove(cssClasses.loading);
        if (selectors.msgStatus != null)
          selectors.msgStatus.classList.add(cssClasses.failed);
        if (error.response.data.errors) {
          const errorMessages = Object.values(error.response.data.errors)
            .flat()
            .join('<br>');
          selectors.msgSuccess.innerHTML = errorMessages;
        } else {
          selectors.msgSuccess.innerHTML = messages.failed;
        }
        modal.openModal();
        selectors.btnOk.innerHTML = "OK";
        modal.openModal();
        console.warn("Realestate onSend() Error", error);
      });
  }
})();
